// External
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { navigate, useBasePath } from "raviger";
import Lottie from "react-lottie-player";
// Components
// import Header from "../components/Header";
import ProgressBone from "../components/ProgressBone";
import Floor from "../components/Floor/Floor";
import Postcode from "../components/Fields/Postcode";
import { TextInput, Button } from "../components/Fields";

import InfoButton from "../components/InfoButton";
// Actions
import { changeNavigation } from "../store/actions/navigation";
import { updateInformation } from "../store/actions/answers";

import { useDesktop } from "../utils/useDesktop";
import animationData from "../static/lottie/Dog_Loading.json";
// import { useScrollY } from "../utils/useScrollY";

import Policy from "../components/Policy";
// Scss
import "./AlmostThere.scss";

const AlmostThere = () => {
	const basepath = useBasePath();
	const dispatch = useDispatch();
	const isDesktop = useDesktop();

	const [isPopUpWindowOpen, setIsPopUpWindowOpen] = useState(false);

	const onToggle = () => {
		setIsPopUpWindowOpen((state) => !state);
	};

	// useEffect(() => {
	// 	window.addEventListener("load", (event) => {
	// 		document.querySelector(".header").style.height = "0px";
	// 	});
	// }, []);

	const currentSurveyStep = useSelector(
		(state) => state.navigation.surveyStep,
	);

	const questions = useSelector((state) => {
		return state.questions.questions;
	});

	// states
	const [age, setAge] = useState("");
	const [email, setEmail] = useState("");
	const [postcode, setPostcode] = useState("");
	const [dontLiveInAustralia, setDontLiveInAustralia] = useState(false);
	const [disabled, setDisabled] = useState(true);
	const [playLottie, setPlayLottie] = useState(false);

	let storeAge = useSelector((state) => state.answers.age);
	let storePostCode = useSelector((state) => state.answers.postcode);
	let storeEmail = useSelector((state) => state.answers.email);

	useEffect(() => {
		if (storeAge) {
			setAge(storeAge);
		}
	}, [storeAge]);

	useEffect(() => {
		if (storePostCode) {
			setPostcode(storePostCode);
		}
	}, [storePostCode]);

	useEffect(() => {
		if (storeEmail) {
			setEmail(storeEmail);
		}
	}, [storeEmail]);

	useEffect(() => {
		dispatch(
			changeNavigation({
				surveyStep: 5,
				theme: {
					foreground: `theme5_foreground`,
					background: `theme5_background`,
				},
			}),
		);
	}, [dispatch]);

	useEffect(() => {}, [dontLiveInAustralia]);

	useEffect(() => {
		if (age.length >= 3) {
			setAge(age.substring(1));
		}
	}, [age]);

	useEffect(() => {
		if (
			(age && email !== "" && dontLiveInAustralia) ||
			(age && email && postcode !== "")
		) {
			setDisabled(false);
			dispatch(
				updateInformation({
					age,
					email,
					postcode,
					dontLiveInAustralia,
				}),
			);
		} else {
			setDisabled(true);
		}
	}, [age, postcode, email, dispatch, dontLiveInAustralia]);

	const onHandleSubmit = () => {
		if (age && email) {
			dispatch(
				updateInformation({
					age,
					email,
					postcode,
					dontLiveInAustralia,
				}),
			);

			if (isDesktop) {
				setPlayLottie(true);
				navigate(basepath + "/wait");
			} else {
				navigate(basepath + "/wait");
			}
		} else {
			window.alert("All inputs are required");
		}
	};

	const onFormSubmit = (e) => {
		e.preventDefault();
		onHandleSubmit();
	};

	const onBackButton = () => {
		// find last question
		// and navigate to it
		const lastQuestion = questions[questions.length - 1];

		dispatch(
			changeNavigation({
				currentQuestion: String(lastQuestion.id),
				surveyStep: lastQuestion.survey_step,
			}),
		);

		dispatch(
			updateInformation({
				age,
				email,
				postcode,
				dontLiveInAustralia,
			}),
		);

		navigate(`${basepath}/questions/${lastQuestion.id}`);
	};

	const onPostcodeChange = (value) => {
		setPostcode(value);
	};

	const onDontLiveInAustraliaChange = useCallback(() => {
		setDontLiveInAustralia((state) => !state);
	}, []);

	return currentSurveyStep === 5 ? (
		<div className="almost-there-container">
			<ProgressBone step={5} />

			<div
				className="almost-there"
				style={{ flexDirection: isDesktop ? "row" : "column" }}
			>
				{/* <Header /> */}

				<div className="form-container">
					<h3>Almost there!</h3>
					<p className="description">
						We just need a few details so we can show you your
						Competible matches! Or, if we didn’t find the dog who’s
						right for you today, we’ll alert you when new matches
						come up.
						<InfoButton
							open={isPopUpWindowOpen}
							// information={<Policy />}
							onToggle={onToggle}
							html={<Policy />}
						/>
					</p>
					<form onSubmit={onFormSubmit}>
						<TextInput
							input
							type="email"
							placeholder="Email Address"
							setStateValue={(e) => setEmail(e)}
							value={email}
						/>

						<TextInput
							type="number"
							input
							placeholder="Age"
							setStateValue={(e) => setAge(e)}
							min="0"
							max="99"
							step="1"
							value={age}
						/>

						<p className="description">
							<i>
								Remember, you need to be 18 or over or have a
								guardian present.
							</i>
						</p>

						<Postcode
							onPostcodeChange={onPostcodeChange}
							onDontLiveInAustraliaChange={
								onDontLiveInAustraliaChange
							}
							value={postcode}
							dontLiveInAustralia={dontLiveInAustralia}
							fish="sticlks"
						/>

						<label className="checkbox-container">
							<span>I don't live in Australia</span>
							<input
								type="checkbox"
								checked={dontLiveInAustralia}
								onChange={(e) =>
									setDontLiveInAustralia(e.target.checked)
								}
							/>
							<span className="checkmark"></span>
						</label>

						<div className="buttons-container">
							<div id="backBtn">
								<Button label="Back" onClick={onBackButton} />
							</div>

							<Button
								label="Next"
								onClick={onHandleSubmit}
								disabled={disabled}
							/>
						</div>
					</form>
				</div>
				{isDesktop && (
					<div className="waiting-screen-desktop-animation">
						<div className="animation-waiting">
							<Lottie
								className="lottie-container basic"
								animationData={animationData}
								play={playLottie}
								loop={true}
								speed={3}
							/>
						</div>
					</div>
				)}
			</div>
			<Floor id={5} />
		</div>
	) : null;
};

export default AlmostThere;
